import { PlacesSourceAdapterService } from './places-source-adapter.service';

export default angular
  .module('sfMobile.services.places-source-adapter', [
    'sfMobile.services.pubsub',
  ])
  .service('placesSourceAdapterService', PlacesSourceAdapterService).name;
